export { ImgixNextImage, imgixLoader } from "./imgixNextImage";
